import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useLocation } from "react-router-dom";

import {
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  CircularProgress,
} from "@mui/material";
import NavbarSidebarLayout from "../../../components/Dashboard/Layouts/NavbarSidebar";

import { api } from "../../../config/config";

import { EmailRegex } from "../../../components/Validation/EmailRegex";
import { PieceValidation } from "../../../components/Validation/PieceValidation";
import { PhoneRegex } from "../../../components/Validation/PhoneRegex";
import ClientTypeSelection from "../../../components/demande/ClientTypeSelection";
import CnibValid from "../../../components/Functions/CnibValid";
import { handleFileUpload } from "../../../services/uploadService";
import { handleDeleteFile } from "../../../services/deleteFile";
import LocationForm from "../../../components/demande/LocationForm";
import DemandeurInfoForm from "../../../components/demande/DemandeurInfoForm";
import IdentityForm from "../../../components/demande/IdentityForm";
import ParcelOwnerForm from "../../../components/demande/ParcelOwnerForm";
import Branchementform from "../../../components/demande/BranchementForm";
import BreadcrumbsComponent from "../../../components/demande/BreadcrumbsComponent";
import { TitleComponent } from "../../../components/demande/TitleComponent";
import ActivitePdecForm from "../../../components/demande/ActivitePdecForm";
import { SEXE_OPTIONS } from "../../../shared/constants";

const typeBranchement = "avecAbon";
const EditBranchAbonnement = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const [activeStep, setActiveStep] = useState(0);

  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  // La liste de professions
  const [professions, setProfessions] = useState([]);
  const [activitesPdec, setActivitesPdec] = useState([]);
  // liste de villes
  const [villes, setVilles] = useState([]);
  // liste des villages
  const [villages, setVillages] = useState([]);
  const [errorDate, setErrorDate] = useState(false);

  // deactiver le bouton submit lorsqu'on actionne le bouton soumettre
  const [stateSend, setStateSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [newFile, setNewFile] = useState({
    file: null,
    document_parcelle: null,
  });

  const [showDialog, setShowDialog] = useState(false);
  const [selectedBranchement, setSelectedBranchement] = useState(null);

  // cela permet de savoir si l'on modifie une valeur existante ou
  // si on veut veux faire une incrementation
  // edit => on garde la valeur fournie
  // add => on ajout la valeur fournie à la valeur existante
  const [status, setStatus] = useState("edit"); // add

  useEffect(() => {
    if (!location.state?.branchementAbonId) return;

    setIsLoading(true);
    const fetchDemande = async () => {
      try {
        const response = await api.get(
          `/demande/${location.state?.branchementAbonId}`,
        );
        if (response.status === 200) {
          setFormData(response.data.content);
        }
      } catch (error) {
        toast.warning("Erreur Serveur");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDemande();
  }, [location.state?.branchementAbonId]);

  useEffect(() => {
    //Village
    if (formData.ville_id) {
      api
        .get(`village/ville/${formData.ville_id}`)
        .then((response) => {
          if (response.status === 200) {
            const trimmedVillages = response.data.content.map((village) => ({
              id: village?.id,
              name: village?.localite.trim(),
            }));
            setVillages(trimmedVillages);
          }
        })
        .catch(() => {
          errors.village = "Problème de réseau.";
        });
    }
  }, [errors, formData.village_id, formData.ville_id]);

  // Chargement des villes, professions et activites PDEC
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        // Exécution parallèle des deux appels
        const [villesResponse, activitesResponse, professionsResponse] =
          await Promise.all([
            api.get("/ville/cd"),
            api.get("/activitepdec/all"),
            api.get("/profession/all"),
          ]);

        if (!isMounted) return;

        // Traitement des villes
        if (villesResponse.status === 200) {
          const trimmedVilles = villesResponse.data.content.map((ville) => ({
            id: ville.id,
            name: ville.agence.trim(),
          }));
          setVilles(trimmedVilles);
        }

        // Traitement des activités
        if (activitesResponse.status === 200) {
          const secteurActivite = activitesResponse.data.content.map(
            (activite) => ({
              id: activite.ID,
              name: activite.LIBELLE_ACTIVITE.trim(),
              code_activite: activite.CODE_ACTIVITE.trim(),
              key_words: activite.KEYWORDS.trim(),
            }),
          );
          setActivitesPdec(secteurActivite);
        }

        // Traitement des professions
        if (professionsResponse.status === 200) {
          setProfessions(professionsResponse.data.content);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
        // Gérer l'erreur (toast, message, etc.)
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  /*   //Gérer les puissances en fonction du types d'ampérange
  useEffect(() => {
    const updatePuissances = () => {
      if (formData.type_amperage === "monophasé") {
        setPuissances(PuissanceMonophase);
        setShowTableau(true);
        // Si la puisssance n'est pas dans liste, fournir une puissance par defaut
        if (!PuissanceMonophase.some((p) => p.key === formData.puissance)) {
          setFormData((prevData) => ({
            ...prevData,
            puissance: PuissanceMonophase[0].key,
          }));
        }
      } else {
        setPuissances(PuissanceTriphase);
        setShowTableau(false);
        // Si la puisssance n'est pas dans liste fournir une puissance par defaut
        if (!PuissanceTriphase.some((p) => p.key === formData.puissance)) {
          setFormData((prevData) => ({
            ...prevData,
            puissance: PuissanceTriphase[0].key,
          }));
        }
      }
    };

    updatePuissances();
  }, [formData.type_amperage, formData.puissance, formData.tableaux]); */

  const steps = [
    "Type de client",
    "Informations du client",
    "Informations d'identité",
    "Localisation géographique",
    "Informations de parcelle",
    "Information sur le branchement",
    "Secteur d'activité",
    "Validation",
  ];

  const handleNext = () => {
    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setErrors({});
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setErrors(validationErrors);
    }
  };

  const handleBack = () => {
    setStateSend(false);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleChangeVille = (_, value) => {
    setVillages([]); // met la liste des village a zero
    let valeur = value === undefined || value === null ? "" : value?.id;
    //setFormData((prevData) => ({ ...prevData, ville: value?.id }));
    setFormData((prevData) => ({ ...prevData, ville_id: valeur }));
    setIsLoading(true);
    api
      .get(`/village/ville/${value?.id}`)
      .then((response) => {
        if (response.status === 200) {
          const trimmedVillages = response.data.content.map((village) => ({
            id: village?.id,
            name: village?.localite.trim(),
          }));
          setVillages(trimmedVillages);
          setIsLoading(false);
        }
      })
      .catch(() => {});
  };

  const handleFieldFocus = (field) => {
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  // Validation des champs du formulaire
  const validateForm = (formData) => {
    //if (!str.trim()) → Vérifie si str est vide ou ne contient que des espaces.
    const errors = {};
    // Validation en fonction de l'étape active
    if (activeStep === 1) {
      // Validation des champs de nom et prénom
      if (!formData.nom.trim()) {
        errors.nom = "Nom obligatoire";
      } else if (formData.nom.trim().length > 25) {
        errors.nom = "Le nom ne doit pas dépasser 25 caractères";
      }
      if (!formData.prenom.trim()) {
        errors.prenom = "Prenom obligatoire";
      } else if (formData.prenom.trim().length > 25) {
        errors.prenom = "Le prénom ne doit pas dépasser 25 caractères";
      }

      // Validation de l'email
      // Validation de l'email
      // valider uniquement si le champ email est renseigné
      // car ce n'est plus un champ obligatoire
      if (formData.email.trim()) {
        if (!EmailRegex(formData.email.trim())) {
          errors.email = "Format d'email invalide";
        }
      }
      /*  if (!formData.email.trim()) {
        errors.email = "Email obligatoire";
      } else if (!EmailRegex(formData.email.trim())) {
        errors.email = "Format d'email invalide";
      } */

      // Validation du numéro de téléphone
      if (!formData.tel2.trim() || formData.tel2.length < 8) {
        errors.tel2 = "Telephone obligatoire";
      } else if (!PhoneRegex(formData.tel2)) {
        errors.tel2 = "Le numéro de téléphone doit être au format correct.";
      }

      /* // Validation du numéro WhatsApp
      if (!formData.tel1_whatsapp.trim() || formData.tel1_whatsapp.length < 8) {
        errors.tel1_whatsapp = "Telephone obligatoire";
      } else if (!PhoneRegex(formData.tel1_whatsapp)) {
        errors.tel1_whatsapp =
          "Le numéro de téléphone doit être au format correct";
      } */
      // Validation du numéro WhatsApp si fourni sinon ne pas valider facultatif
      const normalizedWhatsapp = formData.tel1_whatsapp.trim();
      const hasWhatsappNumber =
        normalizedWhatsapp && normalizedWhatsapp !== "+226";

      if (hasWhatsappNumber) {
        if (!PhoneRegex(normalizedWhatsapp)) {
          errors.tel1_whatsapp =
            "Le numéro de téléphone doit être au format correct.";
        }
      }

      // Validation de la profession
      if (!formData.profession_id) {
        errors.profession_id = "Vueillez choisir une profession";
      }

      // Validation des informations de l'entreprise
      if (formData.cat_cli_code === "02") {
        if (!formData.numero_rccm?.trim()) {
          errors.numero_rccm = "RCCM obligatoire";
        } else if (formData.numero_rccm.trim().length > 30) {
          errors.rccm = "Le RCCM ne doit pas dépasser 30 caractères";
        }
        if (!formData.nom_entreprise?.trim()) {
          errors.nom_entreprise = "Nom Entreprise obligatoire";
        } else if (formData.nom_entreprise.trim().length > 30) {
          errors.nom_entreprise =
            "Le nom de l'entreprise ne doit pas dépasser 30 caractères";
        }
        if (!formData.numero_ifu?.trim()) {
          errors.numero_ifu = "Numero IFU obligatoire";
        } else if (formData.numero_ifu.trim().length > 30) {
          errors.ifu = "Le numéro IFU ne doit pas dépasser 30 caractères";
        }
      }
    } else if (activeStep === 2) {
      if (!formData.numero_piece.trim() && formData.numero_piece.length < 8) {
        errors.numero_piece = "Numéro piece obligatoire";
      }
      if (!formData.piece) {
        errors.piece = "Type piece obligatoire";
      }

      // Validation de la CNIB
      if (!formData.photo_piece && !newFile.file) {
        errors.photo_piece = "Ce champ est obligatoire";
      } else if (newFile.file && newFile.file.size > 2 * 1024 * 1024) {
        errors.photo_piece = "Le fichier sélectionné est volumineux.";
      } else if (
        newFile.file &&
        !newFile.file.name.toLowerCase().endsWith(".pdf")
      ) {
        errors.photo_piece = "Le fichier doit être un PDF";
      }

      // Validation de la date d'établissement
      if (!formData.date_etablissement.trim()) {
        errors.date_piece = "La date d'etablissement est  obligatoire";
        setErrorDate(true);
      } else if (
        PieceValidation(formData.date_etablissement.replace(/-/g, "/")) ===
        false
      ) {
        errors.date_piece = "Cette date ne peut pas être acceptée.";
        setErrorDate(true);
      }
      // Vérification de l'expiration de la carte d'identité
      if (CnibValid(formData.date_etablissement) >= 10) {
        errors.date_piece = "Votre carte d'identité a expiré.";
        setErrorDate(true);
      }

      // Validation du lieu d'établissement de la pièce
      if (!formData.lieu_etablissement.trim()) {
        errors.lieu_piece = " Lieu d'etablissement de la piece obligatoire";
      }
    } else if (activeStep === 3) {
      // Validation de la zone administrative
      if (!formData.ville_id) {
        errors.ville = "La ville est obligatoire";
      }
      // Validation de la localité
      if (!formData.village_id) {
        errors.village = "Le village est obligatoire";
      }
    } else if (activeStep === 4) {
      // Validation des informations du propriétaire
      if (!formData.prop_nom.trim()) {
        errors.prop_nom = "Ce champ est obligatoire";
      } else if (formData.prop_nom.trim().length > 15) {
        errors.prop_nom = "Le nom ne doit pas dépasser 15 caractères";
      }
      if (!formData.prop_prenom.trim()) {
        errors.prop_prenom = "Ce champ est obligatoire";
      } else if (formData.prop_prenom.trim().length > 20) {
        errors.prop_prenom = "Le prénom ne doit pas dépasser 20 caractères";
      }

      if (!formData.lot) {
        errors.lot = "Numero lot obligatoire";
      }
      if (!formData.parcelle) {
        errors.parcelle = "Numero parcelle Obligatoire";
      }
      if (!formData.section) {
        errors.section = "Numero section Obligatoire";
      }
      if (!formData.document_parcelle && !newFile.document_parcelle) {
        errors.document_parcelle = "Le document de la parcelle est obligatoire";
      } else if (
        newFile.document_parcelle &&
        newFile.document_parcelle.size > 2 * 1024 * 1024
      ) {
        errors.document_parcelle = "Le fichier sélectionné est volumineux.";
      } else if (
        newFile.document_parcelle &&
        !newFile.document_parcelle.name.toLowerCase().endsWith(".pdf")
      ) {
        errors.document_parcelle = "Le fichier doit être un PDF";
      }
    } else if (activeStep === 5) {
      if (formData.tableaux.length <= 0) {
        errors.branchement = "Veuillez ajouter un branchement";
      }
    } else if (activeStep === 6) {
      // validation de l'activite activite_pdec
      if (!formData.activite_pdec_id) {
        errors.activite_pdec = "Veuillez choisir un segement d'activité";
      }
    }
    return errors;
  };

  const handleFileChange = (event) => {
    setNewFile((prevData) => ({ ...prevData, file: event.target.files[0] }));
  };

  const handleFileDocumentChange = (event) => {
    setNewFile((prevData) => ({
      ...prevData,
      document_parcelle: event.target.files[0],
    }));
  };

  const handleChangePhone = (value) => {
    setFormData((prevData) => ({ ...prevData, tel2: value }));
  };
  const handleChangePhoneWhatsapp = (value) => {
    setFormData((prevData) => ({ ...prevData, tel1_whatsapp: value }));
  };

  /**
   * Envoi de la demande
   * @param {String} cnib - le nom de la CNIB deja uploadé
   * @param {String} parcelle  - Le nom du fichier de La parcelle deja upload
   */
  const handleDemande = async (cnib, document) => {
    const normalizedWhatsapp = formData.tel1_whatsapp.trim();
    const submissionData = {
      ...formData,
      photo_piece: cnib,
      document_parcelle: document,
      tel1_whatsapp:
        normalizedWhatsapp && normalizedWhatsapp !== "+226"
          ? normalizedWhatsapp
          : "",
    };

    const validationErrors = validateForm(submissionData);
    if (Object.keys(validationErrors).length === 0) {
      setErrors({});

      // On retire les champs qui n'ont pas été soumis pour validation
      const filteredDataAbonnement = Object.fromEntries(
        Object.entries(submissionData).filter(([key, value]) => value !== null),
      );
      // Soumettre la demande du client
      try {
        setIsLoading(true);
        await api
          .put("/demande", filteredDataAbonnement)
          .then((response) => {
            if (response.status === 201) {
              setFormData({
                typeClient: "particulier",
                //Initialiser avec les valeurs par défaut du formulaire
                service: "",
                exploitation: "",
                section: "",
                lot: "",
                parcelle: "",
                rang: "",
                nom: "",
                prenom: "",
                email: "",
                tel2: "+226",
                tel1_whatsapp: "+226",
                numero_rccm: "",
                numero_ifu: "",
                pb: "",
                profession: "",
                piece: "CNI",
                lieu_etablissement: "",
                date_etablissement: "",
                numero_piece: "",
                latitude: "",
                longitude: "",
                puissance: "3A",
                compteur: "",
                type_amperage: "monophasé", // triphasé
                police: "",
                region: "",
                province: "",
                ville_id: "",
                village_id: "",
                nom_entreprise: "",
                prop_nom: "",
                prop_prenom: "",
                document_parcelle: "",
                file: null,
                tableaux: [],
                activite_pdec_id: "",
                sexe: SEXE_OPTIONS[0].value,
              });

              toast.success("Demande modifiée avec succès.");
              setIsLoading(false);
              setStateSend(true); // désactiver le bouton
              setTimeout(() => {
                navigate("/dashboard");
              }, 2000);
            }
          })
          .catch(() => {
            toast.error("Demande non modifié");
            setIsLoading(false);
          });
      } catch (erreur) {}
    } else {
      setErrors(validationErrors);
    }
  };

  /**
   * Suppression des fichier existants (cnib, document parcelle)
   * Upload des nouveau fichiers puis renvoie des données modifiées
   */
  const handleManageSendDataEdit = async () => {
    let cnibFile = formData.photo_piece; // Par défaut, on garde l'ancien fichier
    let parcelleFile = formData.document_parcelle; // Même chose ici

    setStateSend(true);

    try {
      // Suppression et upload des fichiers si un nouveau fichier est ajouté
      if (newFile.file) {
        if (await handleDeleteFile(formData.photo_piece, setIsLoading)) {
          cnibFile = await handleFileUpload(newFile.file, setIsLoading);
        }
      }
      if (newFile.document_parcelle) {
        if (await handleDeleteFile(formData.document_parcelle, setIsLoading)) {
          parcelleFile = await handleFileUpload(
            newFile.document_parcelle,
            setIsLoading,
          );
        }
      }
      // Envoi des documents (nouveaux ou existants)
      await handleDemande(cnibFile, parcelleFile);
    } catch (error) {
      /*  console.error("Erreur lors de la gestion des fichiers :", error); */
    } finally {
      setStateSend(false);
    }
  };

  // Ajout des branchements
  const addBranchement = (nouveauBranchement) => {
    const { amperage, branchement, tableau } = nouveauBranchement;

    const branchementIndex = formData.tableaux.findIndex(
      (b) =>
        b.amperage === amperage &&
        b.branchement === branchement &&
        b.tableau === tableau,
    );

    setFormData((prev) => {
      const tableaux = [...prev.tableaux];

      if (branchementIndex !== -1) {
        // Si branchement existe
        const updatedBranchement = { ...tableaux[branchementIndex] };

        if (status === "add") {
          updatedBranchement.nombre =
            parseInt(updatedBranchement.nombre) +
            parseInt(nouveauBranchement.nombre);
        } else if (status === "edit") {
          updatedBranchement.nombre = parseInt(nouveauBranchement.nombre);
        }

        tableaux[branchementIndex] = updatedBranchement;
      } else {
        // Nouveau branchement à ajouter
        tableaux.push(nouveauBranchement);
      }

      return {
        ...prev,
        tableaux,
      };
    });
  };

  // Supprimer un branchement par index
  const removeBranchement = (id) => {
    setFormData((prev) => ({
      ...prev,
      tableaux: prev.tableaux.filter((_, index) => index !== id),
    }));
  };

  // Modifier un branchement
  const editBranchement = (indexBranchement) => {
    // On recupere le branchement à partir de son index

    const branchement = formData.tableaux[indexBranchement];

    // Puis le passe au state branchement
    setSelectedBranchement(branchement);
    setStatus("edit");
    setShowDialog(true);
  };

  // Fermer le diaglog
  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  // Ouvrir le modal pour l'ajout
  const handleAdd = () => {
    setStatus("add");
    setShowDialog(true);
    // initialiser le branchement avec des valeurs par defaut selon le type de branchement
    setSelectedBranchement({
      branchement: "monophasé", // triphasé
      amperage: "3A",
      nombre: "1",
      tableau: "",
    });
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <ClientTypeSelection
            formData={formData}
            handleChange={handleChange}
            action="modification"
          />
        );
      case 1:
        return (
          <DemandeurInfoForm
            formData={formData}
            errors={errors}
            professions={professions}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
            handleChangePhone={handleChangePhone}
            handleChangePhoneWhatsapp={handleChangePhoneWhatsapp}
          />
        );
      case 2:
        return (
          <IdentityForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
            handleFileChange={handleFileChange}
            setErrorDate={setErrorDate}
            errorDate={errorDate}
            newFile={newFile}
            action="modification"
          />
        );
      case 3:
        return (
          <LocationForm
            formData={formData}
            errors={errors}
            villes={villes}
            villages={villages}
            handleChangeVille={handleChangeVille}
            handleChange={handleChange}
            isLoading={isLoading}
          />
        );
      case 4: //  Infos sur la parcelle
        return (
          <ParcelOwnerForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
            handleFileDocumentChange={handleFileDocumentChange}
            newFile={newFile}
            action="modification"
          />
        );
      case 5:
        return (
          <div>
            <Button variant="outlined" onClick={handleAdd}>
              Ajouter un branchement
            </Button>
            <Branchementform
              formData={formData}
              errors={errors}
              addBranchement={addBranchement}
              removeBranchement={removeBranchement}
              editBranchement={editBranchement}
              branchement={selectedBranchement}
              openDialog={showDialog}
              onCloseDialog={handleCloseDialog}
              typeBranchement={typeBranchement}
            />
          </div>
        );
      case 6:
        return (
          <ActivitePdecForm
            formData={formData}
            activitesPdec={activitesPdec}
            errors={errors}
            handleChange={handleChange}
            handleFieldFocus={handleFieldFocus}
          />
        );
      case 7:
        return (
          <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8 dark:text-white">
            <Typography
              className="text-center mb-8 dark:text-white"
              variant="h5"
            >
              Voulez-vous vraiment modifier votre demande ?
            </Typography>
          </div>
        );

      default:
        return "Unknown step";
    }
  };

  return (
    <NavbarSidebarLayout>
      <div className="block items-center justify-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <div className="mb-1 w-full">
          <BreadcrumbsComponent service="Modification demande de branchement avec abonnement" />
          <div className="my-8">
            <TitleComponent title="Modification de la demande de branchement avec Abonnement" />

            <div className="flex w-full flex-col gap-y-6 lg:flex-row lg:justify-center lg:gap-y-0 md:flex-row md:justify-center md:gap-y-0">
              <div className=" rounded-lg bg-white p-2 shadow-2xl dark:bg-gray-800  xl:p-8 lg:w-1/2 border-2 lg:p-5">
                <div className="invisible md:visible">
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel>{/*label*/}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </div>
                <div>
                  <Typography className="text-center mb-8" variant="h5">
                    {steps[activeStep]}
                  </Typography>
                  {getStepContent(activeStep)}

                  <div className="flex flex-row justify-between pt-18">
                    <Button
                      color="success"
                      variant="outlined"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Précédent
                    </Button>

                    <div className="flex 1 1 auto" />
                    {activeStep === steps.length - 1 && (
                      <>
                        <Button
                          color="secondary"
                          variant="outlined"
                          onClick={handleManageSendDataEdit}
                          sx={{ mr: 1 }}
                          disabled={stateSend}
                        >
                          {isLoading ? (
                            <>
                              <CircularProgress color="primary" size="1rem" />{" "}
                              En cours ...
                            </>
                          ) : (
                            <>Modifier</>
                          )}
                        </Button>
                      </>
                    )}
                    {activeStep !== steps.length - 1 && (
                      <Button
                        onClick={handleNext}
                        variant="contained"
                        color="success"
                      >
                        Suivant
                      </Button>
                    )}
                  </div>
                  <ToastContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </NavbarSidebarLayout>
  );
  // );
};

export default EditBranchAbonnement;
